import { Button, styled } from "@mui/material";

// Header button
export const HeaderButton = styled(Button)(({ theme }) => {
  const headerColors = theme.barekam.header;

  return {
    color: headerColors.textDark,

    height: "45px",
    alignItems: "center",
    display: "inline-flex",
    justifyContent: "center",
    textTransform: "none",
    gap: "0.5rem",
  };
});

export const HeaderButtonSelected = styled(HeaderButton)(() => ({
  boxShadow: "0px 1px 3px rgba(42, 46, 60, 0.25) inset",
}));

// Header - My addresses
export const MyAddressesButton = styled(Button)(({ theme, startIcon }) => {
  const headerColors = theme.barekam.header;

  return {
    backgroundColor: headerColors.myAddressesButton.background,
    color: theme.barekam.sidebar.textLight,
    padding: startIcon ? "12px 12px 12px 24px" : "12px",

    height: "45px",
    alignItems: "center",
    display: "flex",
    gap: "0.5rem",
    justifyContent: "space-between",
    textTransform: "none",
    borderRadius: "0.5rem",

    "& img": {
      filter: "brightness(10000%) saturate(0%) contrast(10000%) !important",
    },

    "&:hover": {
      backgroundColor: headerColors.myAddressesButton.background,
    },
  };
});

export const NewHomeWhiteButton = styled(Button)(({ theme }) => {
  return {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.main,

    minWidth: "320px",
    height: "64px",
    alignItems: "center",
    display: "flex",
    gap: "0.5rem",
    justifyContent: "center",
    textTransform: "none",
    borderRadius: "0.5rem",
    padding: "15px",
    margin: "0 auto",

    "&:hover": {
      backgroundColor: theme.barekam.background,
    },
  };
});

export const MyAddressesCopyButton = styled(Button)(() => ({
  padding: "0.5rem",
  paddingTop: "1rem",
  paddingBottom: "1rem",
  margin: "unset",

  height: "1.5rem",
  minWidth: "unset",
}));
